/**
 * Angular imports.
 */
import { Component, Input } from '@angular/core';
import { NewLanguageService } from 'src/app/dataservices/new-language/new-language.service';

/**
 * Basic info card contains the banner, title, paragraph for section.
 */
@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss']
})
export class SectionComponent {

  /**
   * Set the Banner src.
   * Set the paragraph.
   * Set the content.
   * Set the error status for required.
   * Set the status for the required filed.
   */
  @Input() banner: string;
  @Input() paragraph: string;
  @Input() content: boolean;
  @Input() hasError: boolean;
  @Input() isRequired: string;
  @Input() isImageBanner: boolean;

  /**
   * Only Multi lang service is allowed.
   */
  constructor(public mls: NewLanguageService) { }
  
}
